import { FunctionComponent } from 'react'
import { ProviderNameSearchField } from '@/modules/accredited-establishments/components/Filters/ProviderNameSearchField'

/**
 * Mobile search by name. The field takes the place of the title and of the
 * chip row; the floating pair becomes the button that closes it.
 */
const ProviderNameSearchBar: FunctionComponent = () => (
  <div
    data-testid='provider-name-search-bar'
    className='w-full py-gl-spacing-04'
  >
    <ProviderNameSearchField />
  </div>
)

export { ProviderNameSearchBar }
